import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { MessageMaintenance } from '../../models/message-maintenance';
import { Subscription } from 'rxjs';
import { TuiAppearance, TuiButton, tuiDialog, TuiSurface } from '@taiga-ui/core';
import { MessageMaintenanceService } from '../../services/message-maintenance.service';
import { HeaderComponent } from '../../header/header.component';
import { TuiCardLarge, TuiHeader } from '@taiga-ui/layout';
import { MessageMaintenanceCardComponent } from '../message-maintenance-card/message-maintenance-card.component';

@Component({
  selector: 'app-maintenance-page',
  standalone: true,
  imports: [
    HeaderComponent,
    TuiCardLarge,
    TuiHeader,
    TuiSurface,
    TuiAppearance,
    MessageMaintenanceCardComponent
  ],
  templateUrl: './maintenance-page.component.html',
  styleUrl: './maintenance-page.component.scss'
})
export class MaintenancePageComponent implements OnInit {
  protected readonly messageMaintenanceList0: WritableSignal<Array<MessageMaintenance> | undefined> = signal(undefined);
  private modal: Subscription | undefined;

  private readonly messageMaintenanceService = inject(MessageMaintenanceService);

  ngOnInit(): void {
    this.messageMaintenanceService.pullList().subscribe({
      next: (messageMaintenanceList) => {
        this.messageMaintenanceList0.set(messageMaintenanceList);
      },
    });
  }

}
